import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'home',
    meta: {
      keepAlive: true // 自定义属性,通过改属性动态设置保活
    },
    component: HomeView
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/login/Register')
  },
  {
    path: '/training',
    name: 'training',
    component: () => import('@/views/Training/index')
  },
  {
    path: '/trainingDetails',
    name: 'trainingDetails',
    component: () => import('@/views/Training/details')
  },
  {
    path: '/apply/:id/:price/:title',
    name: 'apply',
    meta: { isAuth: true },
    component: () => import('@/views/Training/apply')
  },
  {
    path: '/orderSumbit',
    name: 'orderSumbit',
    component: () => import('@/views/Training/orderSumbit')
  },
  {
    path: '/notification',
    name: 'notification',
    component: () => import('@/views/notification/index')
  },
  {
    path: '/notification-details',
    name: 'notification-details',
    component: () => import('@/views/notification/details')
  },
  {
    path: '/commonwealVideo',
    name: 'commonwealVideo',
    component: () => import('../views/commonwealVideo/index.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/course',
    name: 'course',
    component: () => import('../views/course/index.vue')
  },
  {
    path: '/examination',
    name: 'examination',
    component: () => import('../views/course/examination.vue')
  },
  {
    path: '/schedule',
    name: 'schedule',
    component: () => import('../views/mine/schedule.vue')
  },
  {
    path: '/examinationDetails',
    name: 'examinationDetails',
    component: () => import('../views/mine/examinationDetails.vue')
  },
  {
    path: '/orderDetails',
    name: 'orderDetails',
    component: () => import('../views/mine/orderDetails.vue')
  },
  {
    path: '/firmApply/:id',
    name: 'firmApply',
    component: () => import('../views/Training/firmApply.vue')
  },
  {
    path: '/firmOrder',
    name: 'firmOrder',
    component: () => import('../views/Training/firmOrder.vue')
  },
  {
    path: '/wrongAnswers',
    name: 'wrongAnswers',
    meta: { isAuth: true },
    component: () => import('../views/mine/WrongAnswers.vue')
  },
  {
    path: '/memorization',
    name: 'memorization',
    meta: { isAuth: true },
    component: () => import('../views/MemorizationMode/index.vue')
  },
  {
    path: '/mockExam',
    name: 'mockExam',
    meta: { isAuth: true },
    component: () => import('../views/MockExam/index.vue')
  },
  // 企业端路由开始
  {
    path: '/LearningDetails',
    name: 'LearningDetails',
    component: () => import('../views/mine/LearningDetails.vue')
  },
  // 企业端路由结束
  {
    path: '/user',
    name: 'user',
    component: () => import(/* webpackChunkName: "about" */ '../views/user/index.vue'),
    // redirect: "user/setting",
    redirect: () => {
      const user = store.state.user
      if (user && user.groupId === 2) {
        return '/user/enterpriseSetting' // 假设这是另一套路由的路径
      }
      return '/user/setting' // 假设这是默认路由的路径
    },
    children: [
      // 企业端路由开始
      {
        path: 'enterpriseSetting',
        meta: { isAuth: true },
        component: () => import('@/views/user/EnterpriseSettings')
      },
      {
        path: 'StudentProfile',
        meta: { isAuth: true },
        component: () => import('@/views/user/StudentProfile')
      },
      {
        path: 'LearningLog',
        meta: { isAuth: true },
        component: () => import('@/views/user/LearningLog')
      },
      {
        path: 'ExamRecords',
        meta: { isAuth: true },
        component: () => import('@/views/user/ExamRecords')
      },
      // 企业端路由结束
      {
        path: 'setting',
        meta: { isAuth: true },
        component: () => import('@/views/user/setting')
      }, {
        path: 'trainRecord',
        meta: { isAuth: true },
        component: () => import('@/views/user/trainRecord')
      }, {
        path: 'progress',
        meta: { isAuth: true },
        component: () => import('@/views/user/progress')
      }, {
        path: 'examination',
        meta: { isAuth: true },
        component: () => import('@/views/user/examination')
      }, {
        path: 'certificate',
        meta: { isAuth: true },
        component: () => import('@/views/user/certificate')
      }, {
        path: 'message',
        meta: { isAuth: true },
        component: () => import('@/views/user/message')
      }, {
        path: 'order',
        meta: { isAuth: true },
        component: () => import('@/views/user/order')
      }, {
        path: 'invoice',
        meta: { isAuth: true },
        component: () => import('@/views/user/invoice')
      }
    ]
  }
]

const router = new VueRouter({
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})
const createRouter = () => new VueRouter({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: routes
})
export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

router.beforeEach(async (to, from, next) => {
  if (to.meta.isAuth) { // 需要登录
    if (store.state.user.token) { // 已经登录
      if (store.state.user.id) {
        next()
      } else {
        store.dispatch('user/getInfo').then(res => {
          next()
        }).catch(err => {
          store.dispatch('user/logout')
          store.commit('user/SET_LOGINDIGO', true)
        })
      }
    } else { // 未登录
      store.commit('user/SET_LOGINDIGO', true)
      next('/')
    }
  } else {
    if (store.state.user.token) { // 已经登录
      if (store.state.user.hasLogin) {
        next()
      } else {
        store.dispatch('user/getInfo').then(res => {
          next()
        }).catch(err => {
          store.dispatch('user/logout')
          store.commit('user/SET_LOGINDIGO', true)
        })
      }
    } else {
      next()
    }
  }
})

export default router
